<template>
    <div class="pre-trip-complete-day-modal-pretrips-group">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>
.pre-trip-complete-day-modal-pretrips-group {
    padding-right: 8px;
    max-height: 312px;
    overflow: hidden;
    overflow-y: auto;

    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
}
</style>